import React from "react";
import "./Application.css";
import img1 from "../Images/application1.png";
import img2 from "../Images/application2.png";
import img3 from "../Images/application3.png";
import img4 from "../Images/application4.png";
import Button from "../Button/Button";

const Application = () => {
  return (
    <div id="application" className="divWrapper">
      <div className="arvrcontainer">
       <h2 className="heading">Industries We Work With</h2>
        <div className="application-container">
          <div className="application-card">
            <div className="info">
              <h3 className="card-heading">Education</h3>
              <p className="card-para">
                Make learning immersive with virtual classrooms and AR textbooks
                that bring lessons to life anytime, anywhere. Moreover, tools
                bring subjects to life, making lessons more interactive and
                accessible at anytime, anywhere.
              </p>
              {/* <Button /> */}
            </div>
            <div className="info-pic">
              <img src={img2} alt="" />
            </div>
          </div>
          <div className="application-card leftSideImg">
            <div className="info-pic">
              <img src={img3} alt="" />
            </div>
            <div className="info">
              <h3 className="card-heading">Healthcare</h3>
              <p className="card-para">
                Enhance training and care with VR surgery simulations and AR
                diagnostic tools for safer, smarter medical experiences. While
                AR tools support real-time diagnosis and treatment, enhancing
                both learning and patient care.
              </p>
              {/* <Button /> */}
            </div>
          </div>
          <div className="application-card">
            <div className="info">
              <h3 className="card-heading">Retail</h3>
              <p className="card-para">
                Boost engagement and sales with AR try-ons and VR shopping that
                let customers explore products before buying. Also, solutions
                allow customers to explore products virtually, leading to higher
                engagement and more confident purchase decisions.
              </p>
              {/* <Button /> */}
            </div>
            <div className="info-pic">
              <img src={img4} alt="" />
            </div>
          </div>
          <div className="application-card leftSideImg lastapplication-card">
            <div className="info-pic">
              <img src={img1} alt="" />
            </div>
            <div className="info">
              <h3 className="card-heading">Manufacturing</h3>
              <p className="card-para">
                Streamline training and operations through AR-guided workflows
                and VR equipment simulations, all without downtime. Tools help
                workers learn faster, reduce errors, and operate more
                efficiently, all without interrupting real-world production.
              </p>
              {/* <Button /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Application;
